export default {
    operationSuccess: 'SUCCESSFUL OPERATION!',
    operationError: 'OPERATION ERROR!',
    synchronizationSuccess: 'SYNCHRONIZATION COMPLETED!',
    synchronizationError: 'SYNC ERROR!',
    connectionSuccess: 'INTEGRATION CONNECTED!',
    connectionError: 'CONNECTION ERROR!',
}